module.exports = __webpack_public_path__ + "static/24.263904a5.jpg";